import gql from 'graphql-tag';

import { getSingleProp, throwIfResultHasErrors } from 'src/utils/lib/graphql';
import apolloClient from 'src/store/client';
import { FRAGMENT_CONTENT_VALIDATION } from 'src/graphql/generation';
import { FRAGMENT_TEXT_ANNOTATIONS } from 'src/graphql/annotation/schema';

const QUERY = gql`
  query ViewSharedDocumentVariationDetails(
    $shareDocumentId: String!
    $variationId: ID!
    $text: String!
  ) {
    viewSharedDocumentVariationDetails(
      shareDocumentId: $shareDocumentId
      variationId: $variationId
      text: $text
    ) {
      scoring {
        score
        engagementScoreSupportSize
        ageScoreHistogram
        genderScoreHistogram
        language
      }
      annotations {
        ...TextAnnotations
      }
      validations {
        ...ContentValidation
      }
    }
  }
  ${FRAGMENT_CONTENT_VALIDATION}
  ${FRAGMENT_TEXT_ANNOTATIONS}
`;

export const queryViewSharedDocumentVariationDetails = async ({
  shareDocumentId,
  variationId,
  text,
}) => {
  const params = {
    query: QUERY,
    variables: {
      shareDocumentId,
      variationId,
      text,
    },
    fetchPolicy: 'no-cache',
  };

  const result = await apolloClient.query(params);
  throwIfResultHasErrors(result);

  return getSingleProp(result.data);
};
